import { axiosCreate } from '@/services/Api'
export default async function({ slug }) {
  const result = await axiosCreate.get(`/custcategories/slug/${slug}`)

  return result.data
}
